module.exports = __webpack_public_path__ + "static/event-1-3681c2f358f5849d9ed7831d7bf42c38.mp4";